export interface AcquirerDataInterface {
  bankTransactionId?: string;
}

export interface PaymentInterface {
  id?: string;
  status?: string;
  entity?: string;
  amount?: number;
  currency?: string;
  orderId?: string;
  invoiceId?: string | null;
  international?: boolean;
  method?: string;
  amountRefunded?: number;
  refundStatus?: string | null;
  captured?: boolean;
  description?: string | null;
  cardId?: string | null;
  bank?: string | null;
  wallet?: string | null;
  vpa?: string | null;
  email?: string;
  contact?: string;
  notes?: string[];
  fee?: number;
  tax?: number;
  errorCode?: string | null;
  transactionId?: string;
  errorDescription?: string | null;
  errorSource?: string | null;
  errorStep?: string | null;
  errorReason?: string | null;
  paymentProvider?: string;
  acquirerData?: AcquirerDataInterface;
  createdAt?: number;
}
export class AcquirerData implements AcquirerDataInterface {
  bankTransactionId?: string;

  constructor(jsonData: any) {
    this.bankTransactionId = jsonData.bank_transaction_id;
  }
}

export class Payment implements PaymentInterface {
  id?: string;
  entity?: string;
  amount?: number;
  status?: string;
  invoiceId?: string | null;
  bankTransactionId?: string;
  transactionId?: string;
  method?: string;
  currency?: string;
  orderId?: string;
  international?: boolean;
  amountRefunded?: number;
  refundStatus?: string | null;
  captured?: boolean;
  description?: string | null;
  cardId?: string | null;
  paymentProvider?: string;
  bank?: string | null;
  wallet?: string | null;
  vpa?: string | null;
  email?: string;
  contact?: string;
  notes?: string[];
  fee?: number;
  tax?: number;
  errorCode?: string | null;
  errorDescription?: string | null;
  errorSource?: string | null;
  errorStep?: string | null;
  errorReason?: string | null;
  acquirerData?: AcquirerData;
  createdAt?: number;

  constructor(jsonData: any = {}) {
    this.id = jsonData._id;
    this.entity = jsonData.entity;
    this.amount = jsonData.amount;
    this.currency = jsonData.currency;
    this.paymentProvider = jsonData.paymentProvider;
    this.status = jsonData.status;
    this.orderId = jsonData.order_id;
    this.invoiceId = jsonData.invoice_id || null;
    this.international = jsonData.international;
    this.method = jsonData.method;
    this.amountRefunded = jsonData.amount_refunded;
    this.refundStatus = jsonData.refund_status || null;
    this.captured = jsonData.captured;
    this.description = jsonData.description || null;
    this.cardId = jsonData.card_id || null;
    this.bank = jsonData.bank || null;
    this.wallet = jsonData.wallet || null;
    this.vpa = jsonData.vpa || null;
    this.email = jsonData.email;
    this.contact = jsonData.contact;
    this.notes = jsonData.notes || [];
    this.fee = jsonData.fee;
    this.tax = jsonData.tax;
    this.transactionId = jsonData.transactionId;
    this.errorCode = jsonData.error_code || null;
    this.errorDescription = jsonData.error_description || null;
    this.errorSource = jsonData.error_source || null;
    this.errorStep = jsonData.error_step || null;
    this.errorReason = jsonData.error_reason || null;
    this.acquirerData = jsonData.acquirer_data ? new AcquirerData(jsonData.acquirer_data) : undefined;
    this.createdAt = jsonData.created_at;
  }
}
